import React, { useContext } from 'react'
import * as Solver from '../Solver'
import { User } from '../Types'
import { ModuleProfile } from '../ModuleTypes'
import { getGuid } from '../Utils'
import { HubConnection } from '@microsoft/signalr'

export interface SessionType {
  sessionGUID: string
  connection: HubConnection
  solverAvailable: boolean
  user: User
  userProfile: ModuleProfile
  groupName: string
  LMSAvailable: boolean
  faultID: string
  hasError: boolean
  errorMessage: string
}

export const initialSession: SessionType = {
  sessionGUID: getGuid(),
  connection: Solver.setConnection(),
  solverAvailable: false,
  user: {} as User,
  userProfile: {} as ModuleProfile,
  groupName: '',
  LMSAvailable: false,
  faultID: 'F000',
  hasError: false,
  errorMessage: '',
}

const context = React.createContext<SessionType>(initialSession)

export const ModuleContext = context
export const ModuleContextProvider = context.Provider
export const ModuleContextConsumer = context.Consumer

export const useModuleContext = () => {
  const context = useContext(ModuleContext)
  if (!context) {
    throw new Error(
      'useModuleContext must be used within a ModuleContextProvider. Wrap a parent component in <ModuleContextProvider> to fix this error.'
    )
  }
  return context
}